import { z } from "zod";

/**
 * The canonical set of country codes a vendor can be resolved to across the
 * app (login, impersonation, per-country status/inventory resolution). Uses
 * the ISO code GB (not UK) to match the rest of the system.
 */
export const CountryCodeSchema = z.enum(["GB", "NL", "DE", "US", "AU"]);
export type VendorCountryCode = z.infer<typeof CountryCodeSchema>;
